<template>
  <div class="overflow-x-auto rounded-md border border-gray-200 dark:border-gray-500">
    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-500 text-sm">
      <thead class="bg-gray-50 dark:bg-gray-700">
        <tr>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Job ID</th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Ticket ID</th>
          <th
            class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100 cursor-pointer select-none"
            @click="$emit('sort', 'jdate')"
          >
            Date
            <span v-if="sortOrder === 'ASC'" class="ml-1 text-xs">▲</span>
            <span v-else-if="sortOrder === 'DESC'" class="ml-1 text-xs">▼</span>
          </th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Company</th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Tech</th>
          <th class="px-3 py-2 text-right font-medium text-gray-700 dark:text-gray-100">Hours</th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Description</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-gray-500 bg-white dark:bg-gray-700">
        <tr
          v-for="row in rows"
          :key="row.id"
          class="hover:bg-yellow-50 dark:hover:bg-gray-600 cursor-pointer"
          @click="$emit('open', row)"
        >
          <td class="px-3 py-2 whitespace-nowrap font-mono text-xs text-gray-800 dark:text-gray-100">{{ row.id }}</td>
          <td class="px-3 py-2 whitespace-nowrap font-mono text-xs">
            <a v-if="row.ticketID" href="#"
               @click.stop.prevent="$emit('openTicketV2', row.ticketID)"
               class="text-blue-600 dark:text-blue-300 hover:underline">{{ row.ticketID }}</a>
            <span v-else class="text-gray-400 dark:text-gray-300">—</span>
          </td>
          <td class="px-3 py-2 whitespace-nowrap text-gray-800 dark:text-gray-100">{{ formatDate(row.jdate) }}</td>
          <td class="px-3 py-2 whitespace-nowrap text-gray-800 dark:text-gray-100">{{ row.company_name || '—' }}</td>
          <td class="px-3 py-2 whitespace-nowrap text-gray-800 dark:text-gray-100">{{ row.tech_name || '—' }}</td>
          <td class="px-3 py-2 whitespace-nowrap text-right text-gray-800 dark:text-gray-100">{{ formatHours(row.totalTime) }}</td>
          <td class="px-3 py-2 text-gray-800 dark:text-gray-100 max-w-md" :title="row.description">
            <div class="line-clamp-4" v-html="renderMarkdown(row.description, { compact: true, maxLines: 8 })"></div>
          </td>
        </tr>
        <tr v-if="!rows.length">
          <td colspan="7" class="px-3 py-6 text-center text-gray-500 dark:text-gray-300">No results.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { renderMarkdown } from '@/utils/markdown';
defineProps({
  rows: { type: Array, default: () => [] },
  sortOrder: { type: String, default: '' },
});
defineEmits(['open', 'openTicketV2', 'sort']);

function formatDate(d) {
  if (!d || String(d).startsWith('0000')) return '—';
  return String(d).substring(0, 10);
}
function formatHours(h) {
  if (h === null || h === undefined) return '—';
  return Number(h).toFixed(2);
}
</script>
